import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TableCell, TableHead, TableRow, Typography, Checkbox, TableSortLabel } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function BankTableHead(props) {
    const { onSelectAllClick, headCells, order, orderBy, onRequestSort, selected, rows } = props;
    const { t } = useTranslation();
    const { role } = useParams();
    const { info, emulation } = useSelector(state => state.user);
    const roleId = emulation.length ? emulation[emulation.length - 1].info.role_id : info.role_id;

    const filteredHeadCells = headCells.filter(cell => {
        if (cell.id === 'office' || cell.id === 'note') return roleId === 3;
        if (cell.id === 'group') return roleId === 3 || roleId === 4;
        return true;
    });
    
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {filteredHeadCells.map(headCell => {
                    if (headCell.type === 'link') {
                        return (
                            <TableCell key={headCell.id} padding={headCell.disablePadding ? 'none' : 'normal'}>
                                <Typography>{t(headCell.label)}</Typography>
                            </TableCell>
                        );
                    }

                    if (headCell.type === 'statistics') {
                        return (
                            <TableCell
                                key={headCell.id}
                                align="left"
                                padding={headCell.disablePadding ? 'none' : 'normal'}
                            >
                                <Typography>{t(headCell.label)}</Typography>
                            </TableCell>
                        );
                    }

                    if (headCell.type === 'img') {
                        return (
                            <TableCell
                                key={headCell.id}
                                align="left"
                                padding={headCell.disablePadding ? 'none' : 'normal'}
                            >
                                <Typography>{t(headCell.label)}</Typography>
                            </TableCell>
                        );
                    }

                    if (headCell.type === 'image') {
                        return (
                            <TableCell
                                key={headCell.id}
                                align="left"
                                padding={headCell.disablePadding ? 'none' : 'normal'}
                            >
                                <Typography>{t(headCell.label)}</Typography>
                            </TableCell>
                        );
                    }

                    if (headCell.type === 'checkbox') {
                        return (
                            <TableCell key={headCell.id} padding="checkbox">
                                <Checkbox
                                    color="primary"
                                    onChange={onSelectAllClick}
                                    inputProps={{ 'aria-label': 'select all items' }}
                                    {...(selected &&
                                        rows && {
                                            checked: rows?.length > 0 && selected?.length === rows?.length,
                                        })}
                                />
                            </TableCell>
                        );
                    }

                    if (headCell.type === 'options') {
                        if (roleId === 3) {
                            return (
                                <TableCell
                                    key={headCell.id}
                                    align="left"
                                    padding={headCell.disablePadding ? 'none' : 'normal'}
                                >
                                    <Typography>{t(headCell.label)}</Typography>
                                </TableCell>
                            );
                        }
                        return null;
                    }

                    if (headCell.type === 'displayOrder') {
                        if (roleId === 3) {
                            return (
                                <TableCell
                                    key={headCell.id}
                                    align="left"
                                    padding={headCell.disablePadding ? 'none' : 'normal'}
                                >
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : 'asc'}
                                        onClick={createSortHandler(headCell.id)}
                                        sx={{
                                            '& .MuiTableSortLabel-icon': {
                                                opacity: orderBy === headCell.id ? 1 : 0,
                                                transition: 'opacity 0.3s',
                                            },
                                            '&:hover .MuiTableSortLabel-icon': {
                                                opacity: 0.5,
                                            },
                                        }}
                                    >
                                        <Typography>{t(headCell.label)}</Typography>
                                    </TableSortLabel>
                                </TableCell>
                            );
                        }
                        return null;
                    }

                    if (
                        !(roleId === 4 && headCell.id === 'teacher') &&
                        !(roleId === 5 && headCell.id === 'counterparty') &&
                        !(roleId === 5 && headCell.id === 'orderOffice') &&
                        !(role === 'students' && headCell.id === 'counterparty') &&
                        !(role === 'students' && headCell.id === 'orderOffice')
                    ) {
                        return (
                            <TableCell
                                key={headCell.id}
                                align="left"
                                padding={headCell.disablePadding ? 'none' : 'normal'}
                                sortDirection={orderBy === headCell.id ? order : false}
                            >
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy === headCell.id ? order : 'asc'}
                                    onClick={createSortHandler(headCell.id)}
                                    sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            opacity: orderBy === headCell.id ? 1 : 0,
                                            transition: 'opacity 0.3s',
                                        },
                                        '&:hover .MuiTableSortLabel-icon': {
                                            opacity: 0.5,
                                        },
                                    }}
                                >
                                    <Typography>{t(headCell.label)}</Typography>
                                </TableSortLabel>
                            </TableCell>
                        );
                    }
                    return null;
                })}
            </TableRow>
        </TableHead>
    );
}
